"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Translation Registry
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyTagQueryToJSON = exports.CopyTagQueryFromJSONTyped = exports.CopyTagQueryFromJSON = exports.instanceOfCopyTagQuery = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CopyTagQuery interface.
 */
function instanceOfCopyTagQuery(value) {
    var isInstance = true;
    isInstance = isInstance && "items" in value;
    return isInstance;
}
exports.instanceOfCopyTagQuery = instanceOfCopyTagQuery;
function CopyTagQueryFromJSON(json) {
    return CopyTagQueryFromJSONTyped(json, false);
}
exports.CopyTagQueryFromJSON = CopyTagQueryFromJSON;
function CopyTagQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'list': !(0, runtime_1.exists)(json, 'list') ? undefined : json['list'],
        'items': json['items'],
        'form': !(0, runtime_1.exists)(json, 'form') ? undefined : json['form'],
        'allItems': !(0, runtime_1.exists)(json, 'all_items') ? undefined : json['all_items'],
    };
}
exports.CopyTagQueryFromJSONTyped = CopyTagQueryFromJSONTyped;
function CopyTagQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'list': value.list,
        'items': value.items,
        'form': value.form,
        'all_items': value.allItems,
    };
}
exports.CopyTagQueryToJSON = CopyTagQueryToJSON;
